import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-edit-input',
  templateUrl: './edit-input.component.html',
  styleUrls: ['./edit-input.component.css']
})
export class EditInputComponent implements OnInit {
	//@Input() editing: boolean;
	@Input() text: string;
	@Input() maxlength:string;
  @Input() isphoto:string;  
  @Input() disabled: boolean = false;  
	//@Input() placeholdText: string;
	//@Input() figureno: boolean;
	//@Input() titleInput: boolean;
	//@Input() defaultText: string;
	editStr: string;
	max:number;
  isphotolog=false;
	@Output() edited = new EventEmitter<string>();
  @Output() tonext = new EventEmitter<string>();
	//@Output() focused = new EventEmitter<boolean>(true);
	constructor() { }

	ngOnInit(): void {
		//this.placeholdText="input here"
	}
	ngOnChanges(changes: SimpleChanges): void {
    if ('text' in changes) {
      this.editStr = changes.text.currentValue;     
      //console.log(this.figureno) 
    }
	if ('maxlength' in changes) {
      this.max = parseInt(changes.maxlength.currentValue);   
      //console.log(this.max) 
    }
    if ('isphoto' in changes) {
      this.isphotolog=true;
      //console.log(this.isphotolog) 
    }
	/*if ('defaultText' in changes) {//console.log(this.defaultText)
      if(!this.defaultText||this.defaultText.length==0){
		 this.defaultText='text'; 
	  }     
      //console.log(this.figureno) 
    }*/
  }

  /*onBlur(event) {console.log(event)
    this.editing = false;
    if(this.editStr==''){
      //this.editStr='#';	 
  }
    this.edited.emit(this.editStr);
  }
  nameValidate(event){
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  }
  onFocus(){
	this.focused.emit(true);
  }*/
   endEdit(type?) {
    //if(this.editStr){
       
       if(type){
        this.tonext.emit(this.editStr);
       }else{
        this.edited.emit(this.editStr);
       }
	   //this.editStr='';
	//}
    
  }
  toUpper(){
	  this.editStr=this.editStr.toUpperCase();
  }
  toLower(){
	  this.editStr=this.editStr.toLowerCase();
  }  
}
